import * as React from 'react';

import { default as SvgIcon } from './SvgIcon.js';

/**
 * Autogenerated react component for icon BoardroomDuotone
 */
export const BoardroomDuotone = React.forwardRef((props: any, ref: any) => (
  <SvgIcon
    ref={ref}
    viewBox="0 0 256 256"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style type="text/css">{'.st0{opacity:0.2;}'}</style>
    <path
      d="M103.3,213.8c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2l0,0l0,0C91.1,219.2,96.6,213.8,103.3,213.8  M103.3,203.8c-12.3,0-22.3,10-22.3,22.2c0,12.3,10,22.3,22.2,22.3s22.3-10,22.3-22.2l0,0l0,0C125.6,213.7,115.6,203.8,103.3,203.8z "
      fill="currentColor"
    />
    <path
      d="M153.3,213.8c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2l0,0l0,0 C141.1,219.2,146.6,213.8,153.3,213.8 M153.3,203.8c-12.3,0-22.3,10-22.3,22.2c0,12.3,10,22.3,22.2,22.3c12.3,0,22.3-10,22.3-22.2 l0,0C175.6,213.7,165.6,203.8,153.3,203.8L153.3,203.8z"
      fill="currentColor"
    />
    <path
      d="M104.3,17.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2S92.1,36.8,92.1,30l0,0C92.1,23.2,97.6,17.7,104.3,17.7  M104.3,7.7c-12.3,0-22.3,10-22.3,22.2c0,12.3,10,22.3,22.2,22.3s22.3-10,22.3-22.2l0,0C126.6,17.7,116.6,7.7,104.3,7.7L104.3,7.7z"
      fill="currentColor"
    />
    <path
      d="M153.3,17.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2l0,0C141.1,23.2,146.6,17.7,153.3,17.7  M153.3,7.7c-12.3,0-22.3,10-22.3,22.2c0,12.3,10,22.3,22.2,22.3c12.3,0,22.3-10,22.3-22.2l0,0C175.6,17.7,165.6,7.7,153.3,7.7 C153.3,7.7,153.3,7.7,153.3,7.7z"
      fill="currentColor"
    />
    <path
      d="M209.6,115.5c6.8,0,12.2,5.5,12.2,12.2c0,6.8-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2C197.3,121,202.8,115.5,209.6,115.5 C209.6,115.5,209.6,115.5,209.6,115.5 M209.6,105.5c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2 S221.9,105.5,209.6,105.5z"
      fill="currentColor"
    />
    <path
      d="M209.6,67.5c6.8,0,12.2,5.5,12.2,12.2S216.4,92,209.6,92s-12.2-5.5-12.2-12.2C197.3,73,202.8,67.5,209.6,67.5 C209.6,67.5,209.6,67.5,209.6,67.5 M209.6,57.5c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2 S221.9,57.5,209.6,57.5z"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M209.6,67.5c6.8,0,12.2,5.5,12.2,12.2S216.4,92,209.6,92s-12.2-5.5-12.2-12.2C197.3,73,202.8,67.5,209.6,67.5 C209.6,67.5,209.6,67.5,209.6,67.5"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M209.6,115.5c6.8,0,12.2,5.5,12.2,12.2c0,6.8-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2 C197.3,121,202.8,115.5,209.6,115.5C209.6,115.5,209.6,115.5,209.6,115.5"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M209.6,165.5c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2 C197.3,171,202.8,165.5,209.6,165.5C209.6,165.5,209.6,165.5,209.6,165.5"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M153.3,17.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2 C141.1,23.2,146.6,17.7,153.3,17.7C153.3,17.7,153.3,17.7,153.3,17.7"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M104.3,17.7c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.3-12.2,12.3S92.1,36.8,92.1,30C92.1,23.2,97.6,17.7,104.3,17.7 C104.3,17.7,104.3,17.7,104.3,17.7"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M46.4,67.5c6.8,0,12.2,5.5,12.2,12.2S53.2,92,46.4,92s-12.2-5.5-12.2-12.2C34.1,73,39.6,67.5,46.4,67.5 C46.4,67.5,46.4,67.5,46.4,67.5"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M46.4,115.5c6.8,0,12.2,5.5,12.2,12.2c0,6.8-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2 C34.1,121,39.6,115.5,46.4,115.5C46.4,115.5,46.4,115.5,46.4,115.5"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M46.4,165.5c6.8,0,12.2,5.5,12.2,12.2S53.2,190,46.4,190s-12.2-5.5-12.2-12.2C34.1,171,39.6,165.5,46.4,165.5 C46.4,165.5,46.4,165.5,46.4,165.5"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M103.3,213.8c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2 C91.1,219.2,96.6,213.8,103.3,213.8C103.3,213.8,103.3,213.8,103.3,213.8"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M153.3,213.8c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2 C141.1,219.2,146.6,213.8,153.3,213.8C153.3,213.8,153.3,213.8,153.3,213.8"
      fill="currentColor"
    />
    <path
      d="M209.6,165.5c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2l0,0l0,0C197.4,171,202.8,165.5,209.6,165.5  M209.6,155.5c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0C231.8,165.5,221.9,155.5,209.6,155.5z"
      fill="currentColor"
    />
    <path
      d="M46.4,115.5c6.8,0,12.2,5.5,12.2,12.2c0,6.8-5.5,12.2-12.2,12.2s-12.2-5.5-12.2-12.2C34.1,121,39.6,115.5,46.4,115.5 C46.4,115.5,46.4,115.5,46.4,115.5 M46.4,105.5c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2 S58.7,105.5,46.4,105.5z"
      fill="currentColor"
    />
    <path
      d="M46.4,67.5c6.8,0,12.2,5.5,12.2,12.2S53.2,92,46.4,92s-12.2-5.5-12.2-12.2C34.1,73,39.6,67.5,46.4,67.5 C46.4,67.5,46.4,67.5,46.4,67.5 M46.4,57.5c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2S58.7,57.5,46.4,57.5z"
      fill="currentColor"
    />
    <path
      d="M46.4,165.5c6.8,0,12.2,5.5,12.2,12.2S53.2,190,46.4,190s-12.2-5.5-12.2-12.2l0,0l0,0C34.2,171,39.6,165.5,46.4,165.5  M46.4,155.5c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2l0,0C68.7,165.5,58.7,155.5,46.4,155.5z"
      fill="currentColor"
    />
    <path
      d="M166.3,69.2v119h-77v-119H166.3 M107.3,165.2h41v-73h-41 M176.3,59.2h-97v139h97V59.2z M117.3,155.2v-53h21v53H117.3z"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M166.3,69.2v119h-77v-119H166.3 M107.3,165.2h41v-73h-41V165.2z"
      fill="currentColor"
    />
  </SvgIcon>
)) as React.FC<React.ComponentPropsWithRef<typeof SvgIcon>>;

export default BoardroomDuotone;
